import type { JSX } from 'react';
import { useMemo } from 'react';
import type { EpisodeCategory } from '../../../../../common/enums/episodeCategory';
import type { IServiceOrganizationSettings } from '../../../interfaces/serviceOrganizationSettings';
import { compareByServiceCodeSortOrder } from '../../../../../common/utils/serviceSortUtils';
import { ServiceGroupOrganizationStatusSettings } from './ServiceGroupOrganizationStatusSettings';
import { ServiceOrganizationPractitioners } from './ServiceOrganizationPractitioners';
import { ServiceOrganizationSettingWrapper } from './ServiceOrganizationSettingWrapper';

export interface IServiceGroupOrganizationSettingsProps {
    episodeCategory: EpisodeCategory;
    organizationId: string;
    reloadServiceOrganizationSettings: () => Promise<void>;
    serviceOrganizationSettings: IServiceOrganizationSettings[];
}

export function ServiceGroupOrganizationSettings(props: IServiceGroupOrganizationSettingsProps): JSX.Element {
    const sortedServiceOrganizationSettings = useMemo(() => {
        return props.serviceOrganizationSettings.sort(compareByServiceCodeSortOrder);
    }, [props.serviceOrganizationSettings]);

    return (
        <>
            <ServiceGroupOrganizationStatusSettings {...props} />

            {sortedServiceOrganizationSettings.map((serviceOrganizationSetting) => (
                <ServiceOrganizationSettingWrapper
                    key={serviceOrganizationSetting.id}
                    reloadServiceOrganizationSettings={props.reloadServiceOrganizationSettings}
                    serviceOrganizationSetting={serviceOrganizationSetting}
                />
            ))}

            <ServiceOrganizationPractitioners {...props} />
        </>
    );
}
